import { makeStyles } from '@material-ui/core';

import { COLOR_TONE } from '../../shared/styles/colors';

export default makeStyles(() => {
  return {
    buttonRoot: {
      gridArea: '1 / 2 / 2 / 3',
    },
    secondaryButtonRoot: {
      gridArea: 'initial',
    },
    buttonSubmitRoot: {
      width: 'auto',
      padding: '0.25rem 1rem',
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      borderRadius: '0.5rem',
    },
    secondaryButtonSubmitRoot: {
      padding: 0,
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      borderRadius: '0.5rem',
    },
    footerText: {
      color: COLOR_TONE.gray[30],
      fontSize: 12,
      lineHeight: 'normal',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    root: {
      alignItems: 'center',
      display: 'grid',
      gridAutoFlow: 'column',
      gap: '1rem',
      justifyContent: 'end',
      fontSize: '1rem',
      fontStretch: 'normal',
      fontStyle: 'normal',
      fontWeight: 'normal',
      letterSpacing: 'normal',
    },
    checkCodeContainer: {
      borderRadius: '62.4375rem',
      background: COLOR_TONE.gray[10],
    },
    checkCode: {
      color: COLOR_TONE.gray[50],
      fontSize: '0.75rem',
      fontWeight: 600,
    },
  };
});
